import { money, when, houseClass } from './api';

// Shared table: one row per player (game view) or per game (player view).
export const StatsTable = ({ rows, labelKey, labelTitle, onPick, testid }) => (
    <div className="overflow-x-auto rounded-lg border border-white/10" data-testid={testid}>
        <table className="w-full text-xs">
            <thead className="bg-zinc-950 text-zinc-500">
                <tr>
                    <th className="text-left p-2">{labelTitle}</th><th className="text-right p-2">Rounds</th><th className="text-right p-2">Bet</th>
                    <th className="text-right p-2">Won</th><th className="text-right p-2">House</th><th className="text-left p-2">First played</th><th className="text-left p-2">Last played</th>
                </tr>
            </thead>
            <tbody>
                {rows.map((r) => (
                    <tr key={`${r.user_id || ''}-${r.game_id}`} onClick={() => onPick(r)} className="border-t border-white/5 text-zinc-200 cursor-pointer hover:bg-white/5 transition-colors"
                        data-testid={`${testid}-row-${r.user_id || r.game_id}`}>
                        <td className="p-2 font-bold text-white">{r[labelKey]}{r.user_email && <div className="text-[10px] font-normal text-zinc-500">{r.user_email}</div>}</td>
                        <td className="p-2 text-right font-mono">{r.rounds}</td>
                        <td className="p-2 text-right font-mono">{money(r.bet)}</td>
                        <td className="p-2 text-right font-mono">{money(r.won)}</td>
                        <td className={`p-2 text-right font-mono font-bold ${houseClass(r.house)}`}>{money(r.house)}</td>
                        <td className="p-2 whitespace-nowrap text-zinc-400">{when(r.first_played)}</td>
                        <td className="p-2 whitespace-nowrap text-zinc-400">{when(r.last_played)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export const Totals = ({ t }) => (
    <div className="flex flex-wrap gap-4 text-xs text-zinc-400" data-testid="game-players-totals">
        <span>Rounds <b className="text-white">{t.rounds}</b></span><span>Bet <b className="text-white">{money(t.bet)}</b></span>
        <span>Won <b className="text-white">{money(t.won)}</b></span><span>House <b className={houseClass(t.house)}>{money(t.house)}</b></span>
    </div>
);
